import { Component, OnInit, Input } from '@angular/core';
import { GuardianModel } from 'src/app/pathways-ui/models/guardian-model';
import { StudentProfile } from 'src/app/pathways-ui/models/student-profile.model';
import { ReferenceTableService } from 'src/app/pathways-ui/services/reference-table.service';

@Component({
  selector: 'app-student-profile-card-additional-info',
  templateUrl: './student-profile-card-additional-info.component.html',
  styleUrls: ['./student-profile-card-additional-info.component.css']
})
export class StudentProfileCardAdditionalInfoComponent implements OnInit {

  constructor() { }

  @Input() studentProfile: StudentProfile | undefined;
  @Input() _references: ReferenceTableService

  ngOnInit(): void {
  }

  get verifiedStudentContacts(): string {
    let verifiedContacts: string[] = [];

    if (
      this.studentProfile.cellPhoneVerified &&
      this.studentProfile.cellPhone
    ) {
      verifiedContacts.push(this.studentProfile.cellPhone);
    }
    if (
      this.studentProfile.homePhoneVerified &&
      this.studentProfile.homePhone
    ) {
      verifiedContacts.push(this.studentProfile.homePhone);
    }
    if (this.studentProfile.emailVerified && this.studentProfile.email) {
      verifiedContacts.push(this.studentProfile.email);
    }
    if (
      this.studentProfile.secondaryEmailVerified &&
      this.studentProfile.secondaryEmail
    ) {
      verifiedContacts.push(this.studentProfile.secondaryEmail);
    }
    return verifiedContacts.join(', ');
  }

  verifiedGuardianContacts(guardian: GuardianModel): string {
    let verifiedContacts: string[] = [];

    if (
      guardian.primaryContactNumberVerified &&
      guardian.primaryContactNumber
    ) {
      verifiedContacts.push(guardian.primaryContactNumber);
    }
    if (
      guardian.secondaryContactNumberVerified &&
      guardian.secondaryContactNumber
    ) {
      verifiedContacts.push(guardian.secondaryContactNumber);
    }
    if (guardian.emailVerified && guardian.email) {
      verifiedContacts.push(guardian.email);
    }

    return verifiedContacts.join(', ');
  }

}
